export default __webpack_public_path__ + "static/media/cp_geo_pa.3f4707c9.svg";